<template>
  <div class="widget">
    <span class="value">{{ value }}</span>
    <span class="label">{{ label }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  value: {
    type: [String, Number],
    default: 0
  },
  label: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.widget {
  height: 100%;
  aspect-ratio: 1;
  background: url('@/assets/dashboard/meter-bg.svg') center/100% no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.value {
  font-size: 2vh;
  font-weight: 3px;
  color: white;
  text-shadow:
    2px 2px 10px rgba(255, 255, 255, 0.3),
    -2px -2px 10px rgba(255, 255, 255, 0.3);
}
.label {
  font-size: 1.5vh;
  color: rgb(0, 163, 228);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  font-weight: 3px;
  font-style: italic;
  font-weight: bold;
}
</style>
